import { render } from "./PropertySection.vue?vue&type=template&id=8e6e9020&scoped=true"
import script from "./PropertySection.vue?vue&type=script&lang=js"
export * from "./PropertySection.vue?vue&type=script&lang=js"

import "./PropertySection.vue?vue&type=style&index=0&id=8e6e9020&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6e9020"]])

export default __exports__